export default (url) => {
    try {
        return url && new URL(url);
    } catch (err) {
        return null;
    }
};
